import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {PadlockIcon} from '../../../icons'
import CardSection from './CardSection'
import useCreditCardForm from './useCreditCardForm'
import SubmitButton from './SubmitButton'
import SetupError from './SetupError'

const CybersourceCreditCardForm = ({
  dueAmount,
  onSubmitPayment,
  authenticityToken,
  invoiceId,
}) => {
  const {t} = useTranslation('payments')

  const {
    formik,
    cardDetails,
    cardNumberDetails,
    cardCvcDetails,
    acceptedCardBrands,
    isLoadingForm,
    isValid,
    submitErrorMessage,
    isSubmitting,
    setupError,
  } = useCreditCardForm(invoiceId, authenticityToken, onSubmitPayment)

  return (
    <Flex
      as="form"
      direction="column"
      gap="sm"
      mt="md"
      onSubmit={formik.handleSubmit}
      className="fs-mask"
    >
      {setupError ? (
        <SetupError />
      ) : (
        <CardSection
          isLoading={isLoadingForm}
          formik={formik}
          cardDetails={cardDetails}
          cardNumberDetails={cardNumberDetails}
          cardCvcDetails={cardCvcDetails}
          acceptedCardBrands={acceptedCardBrands}
        />
      )}

      {submitErrorMessage && (
        <Box>
          <Text mb="sm" textStyle="body-detail" color="mld.alert.700">
            {submitErrorMessage}
          </Text>
        </Box>
      )}
      <Flex fontSize="14px" color="neutral.80" alignItems="center">
        {t('payments:CreditCardForm.securityMessage')}{' '}
        <PadlockIcon ml="xs" size="24px" />
      </Flex>
      <SubmitButton
        isSubmitting={isSubmitting}
        isDisabled={!isValid}
        paymentAmount={dueAmount}
      />
    </Flex>
  )
}

CybersourceCreditCardForm.defaultProps = {
  onSubmitPayment: () => {},
}

CybersourceCreditCardForm.propTypes = {
  onSubmitPayment: PropTypes.func,
  dueAmount: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
  invoiceId: PropTypes.string.isRequired,
}

export default CybersourceCreditCardForm
